import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import withStyles, { css } from '@bd/bdui-styles';

const defaultStyles = css``;

function FavoritesStatus({ builder, className, favorites, hide, user }) {
  const active = !hide && favorites.length > 0;

  if (!get(builder, 'products.BDWebsiteFavorites.isPurchased')) {
    return null;
  }

  return (
    <div className={className}>
      <div className={`FavoritesStatus ${active ? 'FavoritesStatus-active' : ''}`}>
        <Link name="my-account" params={{ product: 'favorites' }}>
          <img className="FavoritesStatus_icon" src="/images/icon-heart-full.svg" width="16" height="16" alt="" />
          <strong className="FavoritesStatus_totalCount">{favorites.length}</strong><span className="FavoriteUser">{get(user, 'name', 'My Favorites')}</span>
        </Link>
      </div>
    </div>
  );
}

FavoritesStatus.propTypes = {
  builder: PropTypes.object.isRequired,
  className: PropTypes.string,
  favorites: PropTypes.arrayOf(PropTypes.object),
  hide: PropTypes.bool,
  user: PropTypes.object,
};

FavoritesStatus.defaultProps = {
  className: undefined,
  favorites: [],
  hide: false,
  user: undefined,
};

export default withData(
  {
    builder: true,
    favorites: true,
    user: true,
  },
  {
    required: {
      builder: true,
    },
  },
)(withStyles(defaultStyles)(FavoritesStatus));



// WEBPACK FOOTER //
// ./src/bdcoreCandidates/Favorites/FavoritesStatus.js